import React, { useState, useEffect } from "react"

import { Paper, TableRow, TableCell } from "@material-ui/core"

import { stableSort, getComparator } from "App/Component/ui/datatable/utils"

import {
  DatatablesFooterServerSide,
  IconButtonDatatable,
  ModalDeleteConfirm,
  Title,
  Loading,
} from "App/Component/ui"

import { STYLE_DEFAULT_MASTER } from "App/constants/theme"

import {
  useDatatablesServerSide,
  useDatatables,
  useLocalStorageForm,
} from "App/hooks"
import {
  deletePoById,
  getByFilterPO,
  headCells,
  RenderStatusPoBadge,
  RESET_STATE_FORM_FILTER,
} from "./helpers"
import { DownloadIcon, PencilIcon, TrashIcon } from "App/Assets"
import {
  defaultDateDisplay,
  defaultDateInputDisplay,
  defaultToastError,
  defaultToastSuccess,
  formatNumber,
  formatRupiah,
} from "App/utils/helpers"

import {
  BASE_URL_4,
  instance4,
  WMS_LGS_DAFTAR_PO,
  WMS_LGS_PO,
} from "App/constants"
import FormFilterDaftarPO from "./FormFilterDaftarPO"
import { STATUS_TRANSAKSI_PENGAJUAN } from "../PurchaseOrder/helpers"
import fileDownload from "js-file-download"
import { LIST_URL_WAREHOUSE } from "utils/warehouse"
import { FreezeTable } from "components/organism"
import { itSelfEmpty } from "utils/all"

export default function DaftarPo({
  changeTitle,
  changeParentData,
  changeMenu,
  handleClickMenu,
}) {
  const classes = STYLE_DEFAULT_MASTER()
  const [poID, setPoId] = useState(null)
  const [showModalDeleteConfirm, setShowModalDeleteConfirm] = useState(false)

  const handleClickUpdate = async (row) => {
    Promise.resolve()
      .then(() => {
        changeMenu(WMS_LGS_PO)
      })
      .then(() => {
        changeParentData({
          idpo: row?.id,
          nomorPo: row?.nomorPO,
          date: defaultDateInputDisplay(row?.date, true),
          gudang_id: row?.gudang_id,
          gudang: row?.gudang,
          supplier_id: row?.supplier_id,
          supplier: row?.supiler,
          penerima: row?.penerima,
          remark: row?.remark,
          type: "update",
          status: row?.status,
          isOpenDraf: true,
          isProcess: row?.status_transaksi === 1 ? false : true,
          jumlah: 0,
          tax: row?.tax === null ? 0 : row?.tax,
          potongan: row?.potongan === null ? 0 : row?.potongan,
          potongan2: row?.potongan === null ? 0 : formatRupiah(row?.potongan),
          total_jumlah: 0,
          is_persentase_potongan: false,
          diskon_persen: 0,
        })
        changeTitle(WMS_LGS_PO)
        handleClickMenu({
          code: WMS_LGS_PO,
          name: "PO",
        })
      })
  }

  const [rows, setRows] = useState([])
  const [formFilter, setFormFilter] = useLocalStorageForm(
    RESET_STATE_FORM_FILTER,
    WMS_LGS_DAFTAR_PO,
  )
  const [totalData, setTotalData] = useState(0)
  const [loading, setLoading] = useState(false)
  useEffect(() => {
    ;(async () => {
      await setNewData()
    })()
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  const setNewData = async (
    pages = formFilter.pages,
    limit = formFilter.limit,
  ) => {
    setLoading(true)

    const res = await getByFilterPO(formFilter, pages, limit)
    if (res.state) {
      setRows(res.data)
      setTotalData(res.meta.count)
      setLoading(false)
    } else {
      setRows([])
      setLoading(false)
      defaultToastError(res.message)
    }
  }

  const {
    pagination,
    onNext,
    onPrevious,
    handleClickPageNumber,
    handleChangeLimit,
  } = useDatatablesServerSide({ setNewData: setNewData })

  const handleClickDelete = (row) => {
    setPoId(row?.id)
    setShowModalDeleteConfirm(!showModalDeleteConfirm)
  }

  async function deleteList() {
    const res = await deletePoById(poID)
    if (res.state) {
      defaultToastSuccess(res.message)
      setNewData()
    } else {
      defaultToastError(res.message)
    }

    setShowModalDeleteConfirm(false)
  }

  function strReplace(str) {
    var newStr = ""
    for (var i = 0; i < str.length; i++) {
      if (str[i] === "/") {
        newStr += "_"
      } else {
        newStr += str[i]
      }
    }
    return newStr
  }

  const downloadPDF = async (id, name) => {
    setLoading(true)
    const filename = strReplace(name)
    try {
      const api = await instance4.get(
        `${BASE_URL_4}${LIST_URL_WAREHOUSE.purchaseOrderLGS.download}/${id}`,
        {
          responseType: "blob",
        },
      )
      fileDownload(api.data, filename + ".pdf")
    } catch (error) {
      return {
        state: false,
        message: error?.response?.data?.message,
      }
    }
    setLoading(false)
  }

  return (
    <>
      <div className={classes.root}>
        <Title title={"Daftar PO Logistik"} />

        {showModalDeleteConfirm && (
          <ModalDeleteConfirm
            confirmHandle={() => deleteList()}
            setShowModalDeleteConfirm={() => setShowModalDeleteConfirm(false)}
          />
        )}

        <Paper
          className={classes.paper}
          style={{
            padding: "1rem",
          }}
        >
          <FormFilterDaftarPO
            formFilter={formFilter}
            setFormFilter={setFormFilter}
            setNewData={setNewData}
          />
          <Loading show={loading} />
          <TableDaftarPO
            rows={rows}
            classes={classes}
            handleClickDelete={handleClickDelete}
            handleClickUpdate={handleClickUpdate}
            downloadPDF={downloadPDF}
          />
          <DatatablesFooterServerSide
            totalData={totalData}
            pagination={pagination}
            handleChangeLimit={handleChangeLimit}
            onPrevious={onPrevious}
            onNext={onNext}
            currentPage={pagination.page}
            handleClickPageNumber={handleClickPageNumber}
          />
        </Paper>
      </div>
    </>
  )
}

const TableDaftarPO = ({
  rows,
  classes,
  handleClickUpdate,
  handleClickDelete,
  downloadPDF,
}) => {
  const { order, orderBy, handleRequestSort, length } = useDatatables({
    rows: rows,
    orderByDefault: "id",
    orderByRow: ["id"],
  })

  return (
    <FreezeTable
      headCells={headCells}
      handleRequestSort={handleRequestSort}
      order={order}
      length={length}
      orderBy={orderBy}
    >
      {stableSort(rows, getComparator(order, orderBy)).map((row, index) => {
        return (
          <TableRow
            hover
            tabIndex={-1}
            key={index}
            // style={{
            //   backgroundColor: index % 2 === 0 ? "transparent" : "#fff",
            // }}
          >
            <TableCell scope="row" padding="none" align="center">
              {index + 1}
            </TableCell>

            <TableCell scope="row" padding="none" align="center">
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "7px",
                }}
              >
                <IconButtonDatatable
                  onClick={() => downloadPDF(row.id, row?.nomorPO)}
                >
                  <DownloadIcon />
                </IconButtonDatatable>
                <IconButtonDatatable onClick={() => handleClickUpdate(row)}>
                  <PencilIcon />
                </IconButtonDatatable>

                {row.status_transaksi === STATUS_TRANSAKSI_PENGAJUAN && (
                  <IconButtonDatatable onClick={() => handleClickDelete(row)}>
                    <TrashIcon />
                  </IconButtonDatatable>
                )}
              </div>
            </TableCell>
            <TableCell align="left">{row?.id}</TableCell>
            <TableCell align="left">{row?.pembelian_id}</TableCell>
            <TableCell align="left">{row?.nomorPO}</TableCell>
            <TableCell align="left">{defaultDateDisplay(row?.date)}</TableCell>
            <TableCell align="left">{row?.gudang}</TableCell>
            <TableCell align="left">{row?.supiler}</TableCell>
            <TableCell align="left">
              <RenderStatusPoBadge status={row.status_transaksi} />
            </TableCell>
            <TableCell align="left">{row?.processedBy}</TableCell>
            <TableCell align="right">
              {row.total_harga === null ? "0" : formatNumber(row.total_harga- itSelfEmpty(row?.potongan, 0))}
            </TableCell>
            <TableCell align="left">{row?.penerima}</TableCell>
            <TableCell align="left">
              {defaultDateDisplay(row?.createdAt)}
            </TableCell>
            <TableCell align="left">{row?.createdBy}</TableCell>
            <TableCell align="left">
              {defaultDateDisplay(row?.updatedAt)}
            </TableCell>
            <TableCell align="left">{row?.updatedBy}</TableCell>
          </TableRow>
        )
      })}
      {rows.length === 0 && (
        <TableRow>
          <TableCell align="center" colSpan={headCells.length}>
            Tidak ada data
          </TableCell>
        </TableRow>
      )}
    </FreezeTable>
  )
}
